import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  stars: number;
  comment: string;
}
const testimonials: Testimonial[] = [{
  name: 'Santi',
  location: 'Zona Norte',
  stars: 5,
  comment: '¡Che, una locura el paso a paso! Re claro todo. Me armé la mesa infinita en dos días y quedó de 10.'
}, {
  name: 'El Colo',
  location: 'Córdoba',
  stars: 5,
  comment: 'No sabía nada de carpintería y me armé el espejo en un finde. Posta, mil gracias. ¡Quedó mortal!'
}, {
  name: 'Gaby',
  location: 'Rosario',
  stars: 5,
  comment: '¡Zarpado el diseño de las mesas! El efecto infinito es un flash total. Todos mis amigos quieren una igual.'
}, {
  name: 'Marce',
  location: 'La Plata',
  stars: 4,
  comment: 'Me quedé con ganas de ver más modelos de mesas circulares. Igual está buenísimo, 4 estrellas porque quiero más contenido.'
}, {
  name: 'Fede',
  location: 'Mendoza',
  stars: 5,
  comment: 'Compré el ebook y me llegó al toque al mail. El laburo que se mandaron es impecable. ¡Recomendadísimo!'
}, {
  name: 'Nico',
  location: 'CABA',
  stars: 5,
  comment: 'Re copado el autor, le escribí por una duda y me contestó al toque. ¡Buenardo! Se nota que le pone onda.'
}, {
  name: 'Caro',
  location: 'Mar del Plata',
  stars: 5,
  comment: 'Laburo impecable, los planos se entienden perfecto. ¡Recomendadísimo! Hice la mesa ratona y es una joya.'
}, {
  name: 'Tincho',
  location: 'Tucumán',
  stars: 5,
  comment: 'Me ahorré una banda de guita haciéndolo yo mismo. ¡Un 10! La inversión se pagó sola.'
}, {
  name: 'Vane',
  location: 'Salta',
  stars: 4,
  comment: 'Estaría bueno que saques una parte 2 con más diseños. Igual está genial, lo recomiendo al 100%.'
}, {
  name: 'Gonza',
  location: 'San Juan',
  stars: 5,
  comment: '¡Tremendo! Los videos explicativos son re claros. Nunca había hecho nada así y me salió de una.'
}, {
  name: 'Manu',
  location: 'Neuquén',
  stars: 5,
  comment: 'El efecto de profundidad infinita es alucinante. Todos los que vienen a casa se quedan flasheando con la mesa.'
}, {
  name: 'Flor',
  location: 'Santa Fe',
  stars: 5,
  comment: '¡Excelente calidad de contenido! Los diagramas están súper detallados. Vale cada peso.'
}, {
  name: 'Lucho',
  location: 'Corrientes',
  stars: 5,
  comment: 'Pensé que iba a ser más complicado pero con las instrucciones del ebook fue re fácil. ¡Gracias totales!'
}, {
  name: 'Sofi',
  location: 'Bahía Blanca',
  stars: 4,
  comment: 'El tutorial de las luces está 10 puntos, me gustaría que expliques más sobre otros materiales. Igual súper recomendable.'
}, {
  name: 'Maxi',
  location: 'Quilmes',
  stars: 5,
  comment: '¡Brutal! Hice el espejo infinito para mi local y todos me preguntan dónde lo compré. Les paso el ebook.'
}, {
  name: 'Agus',
  location: 'San Luis',
  stars: 5,
  comment: 'La mejor compra que hice este año. Aprendí un montón y encima tengo muebles únicos en casa.'
}, {
  name: 'Dani',
  location: 'Paraná',
  stars: 5,
  comment: '¡Increíble la atención al detalle! Hasta incluye tips para no cagarla con los cortes. Re profesional.'
}, {
  name: 'Clau',
  location: 'Posadas',
  stars: 5,
  comment: 'Mi viejo es carpintero y quedó re sorprendido con el resultado. ¡Dice que está impecable el diseño!'
}, {
  name: 'Facu',
  location: 'Río Cuarto',
  stars: 4,
  comment: '4 estrellas porque quiero más modelos de espejos, ¡subí más contenido que es buenísimo! Pero lo que hay está de 10.'
}, {
  name: 'Juli',
  location: 'Tandil',
  stars: 5,
  comment: 'Lo compré medio con dudas pero la verdad superó mis expectativas. ¡Todo re bien explicado!'
}, {
  name: 'Rodri',
  location: 'Resistencia',
  stars: 5,
  comment: '¡Zarpado! Hice la mesa para el living y es el centro de atención. Todos quieren saber cómo la hice.'
}, {
  name: 'Belu',
  location: 'Formosa',
  stars: 5,
  comment: 'Excelente inversión. Los materiales son fáciles de conseguir y el resultado es espectacular.'
}, {
  name: 'Nacho',
  location: 'Jujuy',
  stars: 5,
  comment: '¡Mortal! Las fotos de referencia ayudan un montón. No me perdí en ningún paso.'
}, {
  name: 'Meli',
  location: 'Catamarca',
  stars: 4,
  comment: 'Me encantó pero me gustaría ver más variantes de tamaños. Igual lo súper recomiendo, está buenísimo.'
}, {
  name: 'Seba',
  location: 'La Rioja',
  stars: 5,
  comment: '¡Impresionante! Nunca pensé que podría hacer algo así. El ebook es oro puro.'
}];
export function TestimonialsSection() {
  const [visibleCount, setVisibleCount] = useState(5);
  const showMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, testimonials.length));
  };
  const visibleTestimonials = testimonials.slice(0, visibleCount);
  const hasMore = visibleCount < testimonials.length;
  return <section className="py-8 px-4 bg-white relative z-10" data-id="element-280">
      <div className="max-w-6xl mx-auto" data-id="element-281">
        <div className="text-center mb-6" data-id="element-282">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-50 border border-yellow-300 text-yellow-700 text-sm font-medium mb-2" data-id="element-283">
            <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-284" />
            Testimonios Reales
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-1 tracking-tight" data-id="element-285">
            Lo que dicen nuestros clientes
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-286">
            Más de 2400 personas ya crearon sus mesas y espejos infinitos
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" data-id="element-287">
          {visibleTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-288">
              <div className="flex items-start justify-between mb-3" data-id="element-289">
                <div data-id="element-290">
                  <h3 className="font-bold text-gray-900" data-id="element-291">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-292">
                    {testimonial.location}
                  </p>
                </div>
                <div className="flex gap-0.5" role="img" aria-label={`${testimonial.stars} de 5 estrellas`} data-id="element-293">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} aria-hidden="true" className={`w-4 h-4 ${i < testimonial.stars ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-294" />)}
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-295">
                {testimonial.comment}
              </p>
            </motion.div>)}
        </div>

        {hasMore && <div className="text-center" data-id="element-296">
            <button onClick={showMore} className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all" data-id="element-297">
              Ver más testimonios
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-298">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-299" />
              </svg>
            </button>
          </div>}
      </div>
    </section>;
}